module.exports = __webpack_public_path__ + "static/media/LK_Report.9687f3ad.svg";